export { default } from "./src/heading.tsx";
export * from "./src/heading.tsx";
